import { useState, useEffect } from 'react';

/**
 * Single fetch for home exhibition banner + section (upcoming is soonest first per API).
 */
export function useExhibitions() {
  const [state, setState] = useState({
    status: 'loading',
    upcoming: [],
    recent: [],
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch('/api/shows.php');
        const data = await r.json().catch(() => ({}));
        if (cancelled) return;
        if (!data.ok) {
          setState({ status: 'error', upcoming: [], recent: [] });
          return;
        }
        setState({
          status: 'ready',
          upcoming: Array.isArray(data.upcoming) ? data.upcoming : [],
          recent: Array.isArray(data.recent) ? data.recent : [],
        });
      } catch {
        if (!cancelled) setState({ status: 'error', upcoming: [], recent: [] });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
